import { HandBookLocalEditings } from "../model/slice";

import { HandBookTemplateViewFilters, IMaterialInHandbookExpenditure } from "../model/types";

export const handbooksModifyWithEditings = <T extends { id: number }>(
  handbooks: Array<T>,
  editings: HandBookLocalEditings<any>
) => {
  const deletionSet = new Set(Object.keys(editings.deletions).map(Number));
  const newItemMap = new Map<number | undefined, any[]>();

  editings.new.forEach((item) => {
    const key = item._originalId ?? undefined;
    if (!newItemMap.has(key)) newItemMap.set(key, []);
    newItemMap.get(key)!.push(item);
  });

  const result: Array<T | any> = handbooks.flatMap((h) =>
    deletionSet.has(h.id) ? [] : [h, ...(newItemMap.get(h.id) || [])]
  );

  return result.concat(newItemMap.get(undefined) || []);
};

export const filterExpenditureMaterials = (
  materials: Array<IMaterialInHandbookExpenditure>,
  viewFilters?: HandBookTemplateViewFilters
) => {
  return materials.filter((m) => {
    // Не показываем работы в списке материалов
    if (m.manual_expenditure?.type === "work") return false;
    // Не фильтруем материалы без указанного manual_expenditure.type
    if (!m.manual_expenditure?.type) return true;
    if (!viewFilters) return true;
    return viewFilters[m.manual_expenditure.type];
  });
};
